import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import styled from 'styled-components';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { RequestApprovedIcon, RequestActiveIcon, RequestPlainIcon } from '~/img';
import colors from '~/constants/colors';
import { KsaManualReviewStatus } from '~/types/ksa/KsaReviewResult';

function manualReviewCell(): ColumnsType<any>[0] {
  return {
    title: () => (
      <TableHeader
        title={getI18n().t('Manual review', { ns: 'agent' })}
        sortingDataKey="manualReviewStatus" // todo
      />
    ),
    dataIndex: 'manualReviewStatus',
    key: 'manualReviewStatus',
    render: (status: KsaManualReviewStatus | undefined) => {
      return (
        <Container>
          {status === 'RESOLVED' ? (
            <RequestApprovedIcon className="agentTableRequestIcon" />
          ) : status === 'NEW_REQUEST' ? (
            <RequestActiveIcon className="agentTableRequestIcon" />
          ) : status === 'IN_WORK' ? (
            <RequestPlainIcon className="agentTableRequestIcon" />
          ) : undefined}
        </Container>
      );
    },
    width: 100,
  };
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .agentTableRequestIcon {
    color: ${colors.textColor};
    font-size: 20px;
  }
`;

export default manualReviewCell;
